var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShowmoreIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 9,
    viewBox: "0 0 14 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.67729 7.91323C7.28499 8.27488 6.67363 8.26533 6.29289 7.8846L0.292893 1.8846C-0.0976311 1.49407 -0.0976311 0.860908 0.292893 0.470383C0.683418 0.0798592 1.31658 0.0798592 1.70711 0.470383L7 5.76328L12.2929 0.470383C12.6834 0.0798592 13.3166 0.0798592 13.7071 0.470383C14.0976 0.860908 14.0976 1.49407 13.7071 1.8846L7.70711 7.8846C7.69719 7.89452 7.68725 7.90407 7.67729 7.91323Z",
    fill: "#151515",
    className: "hc-icons"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowmoreIcon);
export default __webpack_public_path__ + "static/media/showmore-icon.e656ac674aabd43420911eee52efe3ea.svg";
export { ForwardRef as ReactComponent };